import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.self-pickups')
  .factory('$selfPickups', selfPickupsFactory);

/* @ngInject */
function selfPickupsFactory($bringozFactory: $bringozFactory,
                            selfPickupsAPI: BringozApi,
                            SelfPickups_DS: DataStoreConfig,
                            SelfPickups_PN: PushNotificationsConfig) {

  function $selfPickups(id: string) {
    return $bringozFactory(id, selfPickupsAPI, SelfPickups_DS, SelfPickups_PN)
  }

  return $selfPickups
}
